var ko = require('knockout');

ko.components.register('quick-purchase-button', {
  viewModel: require('./quick-purchase-button'),
  template: require('./quick-purchase-button.template')
});

$('[data-quick-purchase-button]').each(function() {
  ko.applyBindings({}, this);
});
